import { newId, type Mutation, type MutationOp } from '@tahi/core';

let lastAt = 0;

/**
 * Strictly increasing default timestamps: per-field last-write-wins compares `${at}|${id}`, so two
 * writes from this device in the same millisecond would otherwise be ordered by their random ids.
 */
export function monotonicNow(): string {
  lastAt = Math.max(Date.now(), lastAt + 1);
  return new Date(lastAt).toISOString();
}

/**
 * A mutation in the exact form the server accepts: `at` in toISOString() form (the server refuses
 * any other format), and a newId() UUID, which is printable ASCII as the server's clock-key
 * ordering requires.
 */
export function makeMutation(
  table: string,
  op: MutationOp,
  rowId: string,
  values: Record<string, unknown> | undefined,
  source: Mutation['source'],
  at: string = monotonicNow(),
): Mutation {
  const iso = new Date(at).toISOString();
  return { id: newId(), table, op, rowId, ...(values ? { values } : {}), at: iso, source };
}
